// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icons/library-tab-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.library-tab-icon {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.arduino-list-widget {
    color: var(--theia-foreground);
}

.arduino-list-widget .search-bar {
    margin: 0px 10px 5px 15px;
}

.arduino-list-widget .search-bar:focus {
    border-color: var(--theia-focusBorder);
}

.arduino-list-widget .filter-bar {
    margin: 0px 10px 5px 15px;
}

.arduino-list-widget .filter-bar > * {
    padding: 5px 5px 0px 0px;
}

.arduino-list-widget .filter-bar .filter {
    display: flex;
    align-items: center;
}

.arduino-list-widget .filter-bar .filter > select {
    width: 120px;
}

.arduino-list-widget .filter-bar .filter-label {
    display: flex;
    width: 50px;
}

.filterable-list-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 100%; /* This has top be 100% down to the \`scrollContainer\`. */
}

.component-list-item {
    padding: 20px 15px 25px;
}

.component-list-item .header {
    padding-bottom: 2px;
    min-height: var(--theia-statusBar-height);
}

.component-list-item .header > div {
    display: flex;
}

.component-list-item .header > div .p-TabBar-toolbar {
    align-self: start;
    padding: unset;
    margin-right: unset;
}

.component-list-item:hover .header > div .p-TabBar-toolbar > div {
    visibility: visible;
}

.component-list-item .header > div .p-TabBar-toolbar > div {
    visibility: hidden;
}

.component-list-item .header .title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1 1 auto;
}

.component-list-item .header .title .name {
    font-family: "Open Sans Bold";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
}

.component-list-item .header .version {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.component-list-item .header .author {
    color: var(--theia-panelTitle-inactiveForeground);
}

.component-list-item .header .version {
    color: var(--theia-panelTitle-inactiveForeground);
    padding-top: 4px;
}

.component-list-item .footer .theia-button.install {
    height: auto; /* resets the default Theia button height in the filterable list widget */
}

.component-list-item .header .installed-version:before {
    min-width: 79px;
    display: inline-block;
    justify-self: end;
    text-align: center;
    background-color: var(
        --theia-arduino-toolbar-dropdown-option-backgroundHover
    );
    padding: 2px 4px 2px 4px;
    font-size: 12px;
    max-height: calc(1em + 4px);
    color: var(--theia-button-background);
    content: attr(version);
    cursor: pointer;
    border-radius: 4px;
}

.component-list-item .header .installed-version:hover:before {
    content: attr(remove);
    text-transform: uppercase;
}

.component-list-item .content {
    display: flex;
    flex-direction: column;
    padding-top: 4px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
}

.component-list-item .content > p {
    margin-block-start: unset;
    margin-block-end: unset;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
}

.component-list-item .content > .info {
    white-space: nowrap;
}

.component-list-item .footer {
    flex-direction: column-reverse;
    padding-top: 8px;
}

.component-list-item .footer > * {
    display: inline-block;
}

.filterable-list-container .separator {
    display: flex;
    flex-direction: row;
}

.filterable-list-container .separator :last-child,
.filterable-list-container .separator :first-child {
    min-height: 8px;
    max-height: 8px;
    min-width: 8px;
    max-width: 8px;
}

div.filterable-list-container
    > div
    > div
    > div
    > div:nth-child(1)
    > div.separator
    :first-child,
div.filterable-list-container
    > div
    > div
    > div
    > div:nth-child(1)
    > div.separator
    :last-child {
    display: none;
}

.filterable-list-container .separator .line {
    max-height: 1px;
    height: 1px;
    background-color: var(--theia-activityBar-inactiveForeground);
    flex: 1 1 auto;
}

.component-list-item:hover .footer > label {
    display: inline-block;
    align-self: center;
}

.component-list-item .info a {
    color: var(--theia-button-background);
    text-decoration: none;
}

.component-list-item a:hover {
    text-decoration: underline;
}

.component-list-item .theia-button.secondary.no-border {
    border: 2px solid var(--theia-button-foreground);
}

.component-list-item .theia-button.secondary.no-border:hover {
    border: 2px solid var(--theia-secondaryButton-foreground);
}

.component-list-item .theia-button {
    margin-left: 12px;
}

.component-list-item .theia-select {
    height: var(--arduino-button-height);
    min-height: var(--arduino-button-height);
    width: 65px;
    min-width: 65px;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/list-widget.css"],"names":[],"mappings":"AAAA;IACI,qDAAkD;IAClD,6CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY,EAAE,wDAAwD;AAC1E;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI,YAAY,EAAE,yEAAyE;AAC3F;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB;;KAEC;IACD,wBAAwB;IACxB,eAAe;IACf,2BAA2B;IAC3B,qCAAqC;IACrC,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;;IAEvB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;;;;;;;;;;;;;;IAcI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;IACxC,WAAW;IACX,eAAe;AACnB","sourcesContent":[".library-tab-icon {\r\n    -webkit-mask: url(\"../icons/library-tab-icon.svg\");\r\n    mask: url(\"../icons/library-tab-icon.svg\");\r\n}\r\n\r\n.arduino-list-widget {\r\n    color: var(--theia-foreground);\r\n}\r\n\r\n.arduino-list-widget .search-bar {\r\n    margin: 0px 10px 5px 15px;\r\n}\r\n\r\n.arduino-list-widget .search-bar:focus {\r\n    border-color: var(--theia-focusBorder);\r\n}\r\n\r\n.arduino-list-widget .filter-bar {\r\n    margin: 0px 10px 5px 15px;\r\n}\r\n\r\n.arduino-list-widget .filter-bar > * {\r\n    padding: 5px 5px 0px 0px;\r\n}\r\n\r\n.arduino-list-widget .filter-bar .filter {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.arduino-list-widget .filter-bar .filter > select {\r\n    width: 120px;\r\n}\r\n\r\n.arduino-list-widget .filter-bar .filter-label {\r\n    display: flex;\r\n    width: 50px;\r\n}\r\n\r\n.filterable-list-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    height: 100%; /* This has top be 100% down to the `scrollContainer`. */\r\n}\r\n\r\n.component-list-item {\r\n    padding: 20px 15px 25px;\r\n}\r\n\r\n.component-list-item .header {\r\n    padding-bottom: 2px;\r\n    min-height: var(--theia-statusBar-height);\r\n}\r\n\r\n.component-list-item .header > div {\r\n    display: flex;\r\n}\r\n\r\n.component-list-item .header > div .p-TabBar-toolbar {\r\n    align-self: start;\r\n    padding: unset;\r\n    margin-right: unset;\r\n}\r\n\r\n.component-list-item:hover .header > div .p-TabBar-toolbar > div {\r\n    visibility: visible;\r\n}\r\n\r\n.component-list-item .header > div .p-TabBar-toolbar > div {\r\n    visibility: hidden;\r\n}\r\n\r\n.component-list-item .header .title {\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 2;\r\n    white-space: normal;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.component-list-item .header .title .name {\r\n    font-family: \"Open Sans Bold\";\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n}\r\n\r\n.component-list-item .header .version {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.component-list-item .header .author {\r\n    color: var(--theia-panelTitle-inactiveForeground);\r\n}\r\n\r\n.component-list-item .header .version {\r\n    color: var(--theia-panelTitle-inactiveForeground);\r\n    padding-top: 4px;\r\n}\r\n\r\n.component-list-item .footer .theia-button.install {\r\n    height: auto; /* resets the default Theia button height in the filterable list widget */\r\n}\r\n\r\n.component-list-item .header .installed-version:before {\r\n    min-width: 79px;\r\n    display: inline-block;\r\n    justify-self: end;\r\n    text-align: center;\r\n    background-color: var(\r\n        --theia-arduino-toolbar-dropdown-option-backgroundHover\r\n    );\r\n    padding: 2px 4px 2px 4px;\r\n    font-size: 12px;\r\n    max-height: calc(1em + 4px);\r\n    color: var(--theia-button-background);\r\n    content: attr(version);\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n}\r\n\r\n.component-list-item .header .installed-version:hover:before {\r\n    content: attr(remove);\r\n    text-transform: uppercase;\r\n}\r\n\r\n.component-list-item .content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding-top: 4px;\r\n    font-family: \"Open Sans\";\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n}\r\n\r\n.component-list-item .content > p {\r\n    margin-block-start: unset;\r\n    margin-block-end: unset;\r\n\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 3;\r\n    white-space: normal;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.component-list-item .content > .info {\r\n    white-space: nowrap;\r\n}\r\n\r\n.component-list-item .footer {\r\n    flex-direction: column-reverse;\r\n    padding-top: 8px;\r\n}\r\n\r\n.component-list-item .footer > * {\r\n    display: inline-block;\r\n}\r\n\r\n.filterable-list-container .separator {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.filterable-list-container .separator :last-child,\r\n.filterable-list-container .separator :first-child {\r\n    min-height: 8px;\r\n    max-height: 8px;\r\n    min-width: 8px;\r\n    max-width: 8px;\r\n}\r\n\r\ndiv.filterable-list-container\r\n    > div\r\n    > div\r\n    > div\r\n    > div:nth-child(1)\r\n    > div.separator\r\n    :first-child,\r\ndiv.filterable-list-container\r\n    > div\r\n    > div\r\n    > div\r\n    > div:nth-child(1)\r\n    > div.separator\r\n    :last-child {\r\n    display: none;\r\n}\r\n\r\n.filterable-list-container .separator .line {\r\n    max-height: 1px;\r\n    height: 1px;\r\n    background-color: var(--theia-activityBar-inactiveForeground);\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.component-list-item:hover .footer > label {\r\n    display: inline-block;\r\n    align-self: center;\r\n}\r\n\r\n.component-list-item .info a {\r\n    color: var(--theia-button-background);\r\n    text-decoration: none;\r\n}\r\n\r\n.component-list-item a:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.component-list-item .theia-button.secondary.no-border {\r\n    border: 2px solid var(--theia-button-foreground);\r\n}\r\n\r\n.component-list-item .theia-button.secondary.no-border:hover {\r\n    border: 2px solid var(--theia-secondaryButton-foreground);\r\n}\r\n\r\n.component-list-item .theia-button {\r\n    margin-left: 12px;\r\n}\r\n\r\n.component-list-item .theia-select {\r\n    height: var(--arduino-button-height);\r\n    min-height: var(--arduino-button-height);\r\n    width: 65px;\r\n    min-width: 65px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
